import { render, staticRenderFns } from "./CopyItem.vue?vue&type=template&id=0425e045&scoped=true"
import script from "./CopyItem.vue?vue&type=script&lang=js"
export * from "./CopyItem.vue?vue&type=script&lang=js"
import style0 from "./CopyItem.vue?vue&type=style&index=0&id=0425e045&prod&scoped=true&lang=css"
import style1 from "./CopyItem.vue?vue&type=style&index=1&id=0425e045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0425e045",
  null
  
)

export default component.exports